import React from 'react';

import { ELEVIO_PORTAL_URL } from '@private-crm-app/constants';
import { getElevioPortalHomeUrl, redirectTo } from '@private-crm-app/utils';

export default function LogoutHandler() {
  const redirectUrl = localStorage.getItem(ELEVIO_PORTAL_URL) || getElevioPortalHomeUrl();

  if (redirectUrl) {
    redirectTo(redirectUrl);
  }

  return <h1>You have been successfully logged out! Redirecting to home page...</h1>;
}
